import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MFAScreen from "../Screens/MFAScreen";

const AuthCheckRoute = () => {
  const showMFA = useSelector((state) => state?.mfa?.showMFA);
  console.log(showMFA);
  if (showMFA) {
    // return <Navigate to="/login" replace />;
    return <MFAScreen />
  }
  return <Navigate to="/login" replace />;
};

export default AuthCheckRoute;
